import React from 'react'

function CrossIcon(props) {
  return (
    <svg
      {...props}
      className={`${props.className} cross-icon`}
      width='27'
      height='26'
      viewBox='0 0 27 26'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <line
        x1='1.41421'
        y1='1'
        x2='24.0416'
        y2='23.6274'
        stroke='black'
        strokeWidth='2'
        strokeLinecap='round'
      />
      <line
        x1='2'
        y1='23.6275'
        x2='24.6274'
        y2='1.00012'
        stroke='black'
        strokeWidth='2'
        strokeLinecap='round'
      />
    </svg>
  )
}

export default CrossIcon
